import axios from '@/utils/axios';

export class AnalyticsService {
  static sendAnalytics(payload: {
    gmb_address?: number;
    medium: number;
    action: number;
  }): Promise<any> {
    return axios.post('analytics/', payload);
  }
}
